import React, { useCallback } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { toggleUIVersion } from "utils/switchUI";

const SwitchUIVersion = ({ isNewVersionEnabled = false, containerClassName = null }) => {
  const toggleVersion = useCallback(() => {
    try {
      toggleUIVersion(isNewVersionEnabled);
    } catch (error) {
      console.error(error);
    }
  }, [isNewVersionEnabled]);

  return (
    <div className={containerClassName} onClick={toggleVersion}>
      Switch to {isNewVersionEnabled ? "Old" : "New"} UI
    </div>
  );
};

const mapStateToProps = createStructuredSelector({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SwitchUIVersion);
